
<template>
    <div class="info-box" v-bind:class="'info-box--' + type">
   
        <div class="row g-0">
            <div class="col-24">
                <div class="inner-content">
                    <slot name='body'></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'InfoBox',
        props: {
            type: String,
        },
      
    }
</script>
<style src="@/css/info-box.css"></style>